import {styled} from "styled-components";
import {Card, Divider} from "antd";

export const CustomDivider = styled(Divider)`
    margin: 16px 0;
    border-block-start: 1px solid rgba(5, 5, 5, 0.1);
`;
